export default __webpack_public_path__ + "static/do-links-underlined-1a239e33b048b3f64fb76b5bf62ccca0.png";